import { ThemeProvider, Tooltip } from '@alphonsocode/kallos';
import React, { useState } from 'react';
import { MdInfoOutline } from 'react-icons/md';
import { track } from 'analytics/posthog';

function TestTypeTabs({ selectedTestType, setTestTypeState }) {
  const buttonStyles = button => ({
    borderRadius: '9999px',
    cursor: 'pointer',
    fontFamily: "lg-smart', sans-serif",
    fontSize: '14px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    backgroundColor: selectedTestType === button ? '#1a6d80' : '#d1d1d1',
    color: selectedTestType === button ? 'white' : 'black',
    padding: '7px 20px',
  });

  const iconStyles = {
    fontSize: '20px',
    fontWeight: 'bold',
  };

  return (
    // @ts-ignore - ThemeProvider children type issue with React 18
    <ThemeProvider defaultMode="light">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '92%',
          backgroundColor: '#d1d1d1',
          borderRadius: '9999px',
        }}
      >
        <button
          style={buttonStyles('cta')}
          onClick={() => {
            track('adsure test type changed', {
              adsure_test_tag: 'cta',
              surface: 'adsure',
            });
            setTestTypeState('cta');
          }}
        >
          Unique CTA Test
          <Tooltip
            overlay="These creative tests are designed to test the Unique CTA (Destination Details) for a campaign. A Unique CTA is defined as a distinct combination of Country and Click-through Destination Details that the creatives of the respective campaign have used in the past month. Every Unique CTA for a campaign is tested on all available WebOSs and WeeTVs available for automated testing."
            openDelay={0}
            closeDelay={0}
            arrow={false}
            style={{
              maxWidth: '300px',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              marginTop: 5,
              marginLeft: 10,
            }}
          >
            <span>
              <MdInfoOutline style={iconStyles} />
            </span>
          </Tooltip>
        </button>
        <button
          style={buttonStyles('ad-render')}
          onClick={() => {
            track('adsure test type changed', {
              adsure_test_tag: 'ad-render',
              surface: 'adsure',
            });
            setTestTypeState('ad-render');
          }}
        >
          Ad Rendering Test
          <Tooltip
            overlay="These creative tests are designed to test the ad rendering of the creative, for ad-rendering testing we test every creative on one WebOS & one WeeTV."
            openDelay={0}
            closeDelay={0}
            arrow={false}
            style={{
              maxWidth: '300px',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              marginTop: 5,
            }}
          >
            <span>
              <MdInfoOutline style={iconStyles} />
            </span>
          </Tooltip>
        </button>
        <button
          style={buttonStyles('on-demand')}
          onClick={() => {
            track('adsure test type changed', {
              adsure_test_tag: 'on-demand',
              surface: 'adsure',
            });
            setTestTypeState('on-demand');
          }}
        >
          On Demand Test
          <Tooltip
            overlay="Users can submit tests on-demand for a specific ad slot and country without setting up a campaign in Mosaic, and verify the results on Adsure."
            openDelay={0}
            closeDelay={0}
            arrow={false}
            style={{
              maxWidth: '300px',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              marginTop: 5,
            }}
          >
            <span>
              <MdInfoOutline style={iconStyles} />
            </span>
          </Tooltip>
        </button>
        <button
          style={buttonStyles('ssp')}
          onClick={() => {
            track('adsure test type changed', {
              adsure_test_tag: 'ssp',
              surface: 'adsure',
            });
            setTestTypeState('ssp');
          }}
        >
          Programmatic Ads Test
          <Tooltip
            overlay="These test results are sourced from SSP-triggered Programmatic ad runs executed in AdSure and include device targeting, TV-side validation, and uploaded visual artifacts."
            openDelay={0}
            closeDelay={0}
            arrow={false}
            style={{
              maxWidth: '300px',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              marginTop: 5,
            }}
          >
            <span>
              <MdInfoOutline style={iconStyles} />
            </span>
          </Tooltip>
        </button>
      </div>
    </ThemeProvider>
  );
}

export default TestTypeTabs;
